import licenseDiscountPopover from './license-seats-discount-popover.html';

/* @ngInject */
export const templates = ($templateCache: ng.ITemplateCacheService) => {
	$templateCache.put('license-seats-discount-popover.html', licenseDiscountPopover);
};
